import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path
    class="cls-1"
    d="M13,20h7V4H4v7h7a2,2,0,0,1,2,2ZM4,2H20a2,2,0,0,1,2,2V20a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2Z"
  />,
  "GuardianExpand"
);
